import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DataService } from './data.service';
import { Buffer } from 'buffer';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor(private dataService: DataService) {}
  public rotateIcon: boolean = false;

  public isEmpty(obj: any): any {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  public deepCopy(item: any): any {
    return JSON.parse(JSON.stringify(item));
  }

  fnStringify(obj: any): any {
    return JSON.stringify(obj);
  }

  public existsIn(arr: any, item: any): any {
    return arr.includes(item);
  }

  public fnGetKeys(obj: any = {}): any {
    return Object.keys(obj);
  }

  public addSpaces(str: string): string {
    if (str) {
      str = str
        .replace(/([A-Z])/g, ' $1')
        .replace(/-/g, ' ')
        .replace(/_/g, ' ')
        .trim();
    }
    return str;
  }

  public toCamelCase(str: string): string {
    return str
      .trim()
      .toLowerCase()
      .replace(/([^A-Z0-9]+)(.)/gi, function (match) {
        return arguments[2].toUpperCase();
      });
  }

  public fnBlobToBase64(blob: Blob): string {
    let base64data: any;
    let reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function () {
      base64data = reader.result;
    };

    return base64data;
  }

  private flatten_recurse(
    cur: any,
    result: any,
    delim: string = '.',
    prop: any = ''
  ) {
    if (Object(cur) !== cur) {
      // Step - Object;
      result[prop] = cur;
    } else if (Array.isArray(cur)) {
      // Step - Array;
      for (var i = 0, l = cur.length; i < l; i++)
        this.flatten_recurse(cur[i], result, delim, prop + '[' + i + ']');
      if (l == 0) {
        result[prop] = [];
      }
    } else {
      // Step - else;
      var isEmpty = true;
      for (var p in cur) {
        isEmpty = false;
        this.flatten_recurse(
          cur[p],
          result,
          delim,
          prop ? prop + delim + p : p
        );
      }
      if (isEmpty && prop) {
        result[prop] = {};
      }
    }
  }

  public flatten(data: any, delim: string = '.'): any {
    var result = {};
    this.flatten_recurse(data, result, delim);
    return result;
  }

  public unflatten(data: any): any {
    'use strict';
    if (Object(data) !== data || Array.isArray(data)) return data;
    var regex = /\.?([^.\[\]]+)|\[(\d+)\]/g,
      resultholder = {};
    for (var p in data) {
      var cur: any = resultholder,
        prop = '',
        m;
      while ((m = regex.exec(p))) {
        cur = cur[prop] || (cur[prop] = m[2] ? [] : {});
        prop = m[2] || m[1];
      }
      cur[prop] = data[p];
    }
    return resultholder;
  }

  public mongoUUID(): string {
    var timestamp = ((new Date().getTime() / 1000) | 0).toString(16);
    return (
      timestamp +
      'xxxxxxxxxxxxxxxx'
        .replace(/[x]/g, function () {
          return ((Math.random() * 16) | 0).toString(16);
        })
        .toLowerCase()
    );
  }

  uniqueConcat(array1: Array<any>, array2: Array<any>, key: string): any {
    let array3 = [];

    array3 = array1.filter((ar1) =>
      array2.filter((ar2) => ar2[key] !== ar1[key])
    );

    return array3;
  }

  public addMonthYear(month: number, year: number, increment: number) {
    let returnMonth = month;
    let returnYear = year;
    if (month + increment > 11) {
      return [month + increment - 12, returnYear + 1];
    }
    if (month + increment < 0) {
      return [12 + (month + increment), returnYear - 1];
    }
    return [returnMonth + increment, returnYear];
  }

  public deepEquals(x: any, y: any) {
    if (x === y) {
      return true; // if both x and y are null or undefined and exactly the same
    } else if (!(x instanceof Object) || !(y instanceof Object)) {
      return false; // if they are not strictly equal, they both need to be Objects
    } else if (x.constructor !== y.constructor) {
      // they must have the exact same prototype chain, the closest we can do is
      // test their constructor.
      return false;
    } else {
      for (const p in x) {
        if (!x.hasOwnProperty(p)) {
          continue; // other properties were tested using x.constructor === y.constructor
        }
        if (!y.hasOwnProperty(p)) {
          return false; // allows to compare x[ p ] and y[ p ] when set to undefined
        }
        if (x[p] === y[p]) {
          continue; // if they have the same strict value or identity then they are equal
        }
        if (typeof x[p] !== 'object') {
          return false; // Numbers, Strings, Functions, Booleans must be strictly equal
        }
        if (!this.deepEquals(x[p], y[p])) {
          return false;
        }
      }
      for (const p in y) {
        if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) {
          return false;
        }
      }
      return true;
    }
  }

  emailValidation = (control: AbstractControl) => {
    if (!control.value) {
      return null;
    }
    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(control.value)) {
      return { emailError: true };
    }
    return null;
  };

  //USA pattern breakdown
  /**
  *      ^(?:\+1[-.\s]?)?:
        ^: This indicates the start of the string.
        (?:...): This is a non-capturing group that groups parts of the pattern together without storing the match for later use.
        \+1: This matches the country code for the USA, which is +1. The + symbol is escaped with a backslash (\) since it has a special meaning in regex.
        [-.\s]?: This matches an optional separator after the country code. It can be either a hyphen (-), a dot (.), or a whitespace character (\s).
        ?: This makes the whole group (the country code and separator) optional, meaning the number may or may not include the +1 country code.
        
        \(?([2-9][0-9]{2})\)?:
        \(?: This optionally matches an opening parenthesis ( around the area code.
        [2-9]: The first digit of the area code must be between 2 and 9 (to prevent invalid area codes starting with 0 or 1).
        [0-9]{2}: The next two digits can be any number from 0 to 9, completing the three-digit area code.
        \)?: This optionally matches a closing parenthesis ) around the area code.
        
        [-.\s]?:
        This matches an optional separator (hyphen, dot, or space) after the area code.
        
        [0-9]{3}:
        This matches exactly three digits, which represent the first part of the phone number (the central office code).
        
        [-.\s]?:
        Another optional separator (hyphen, dot, or space) after the first part of the phone number.
        
        [0-9]{4}:
        This matches exactly four digits, representing the final part of the phone number (the line number).
        
        $:
        This asserts the end of the string, ensuring the entire string is a valid phone number with no extra characters.
  * 
  * 
  * Examples of matching phone numbers:
      +1 202-555-0123
      +1 (202) 555-0123
      +1-202-555-0123
      202 555 0123
  *  */
  phoneValidation = (control: AbstractControl) => {
    // (?:\+91-?)?: This part of the pattern is for the country code. It allows for the country code +91 to be optionally present, followed by an optional hyphen (-).
    // [6-9]: Matches the first digit of the phone number, which should be 6, 7, 8, or 9.
    // \d{9}: Matches the next 9 digits.
    // $: Denotes the end of the string.
    const indiaPattern = /^(?:\+?91[-\s]?)?[6-9]\d{9}$/;

    const usaPattern =
      /^(?:\+?1[-.\s]?)?\(?([2-9][0-9]{2})\)?[-.\s]?[0-9]{3}[-.\s]?[0-9]{4}$/;
    if (!indiaPattern.test(control.value) && !usaPattern.test(control.value)) {
      return { phone: true };
    }
    return null;
  };

  passwordValidation = (control: AbstractControl) => {
    if (!this.dataService.passwordRegex.test(control.value)) {
      return { password: true };
    }

    return null;
  };

  getUtilizationColor = (value: number) => {
    if (value >= 90) {
      return 'green';
    } else if (value >= 70) {
      return 'orange';
    } else {
      return 'red';
    }
  };

  makeid(length: number) {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@$~*&-=+';
    const charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  getShareKeyString(password: string) {
    // let enPass = Base64.encode(JSON.stringify(password));
    const buffer = Buffer.from(JSON.stringify(password));
    let enPass = buffer.toString('base64');
    var sharingKey = '';
    var newPassword = sharingKey.concat(
      this.makeid(15),
      enPass,
      this.makeid(14)
    );
    const buffer2 = Buffer.from(JSON.stringify(newPassword));
    var encodeString = buffer2.toString('base64');
    console.log(encodeString, 'passcode');
    return encodeString;
  }

  getDecryptedText(encryptedText: string): string | undefined {
    // Decode the base64-encoded string
    let buff = Buffer.from(encryptedText, 'base64');
    let msg = buff.toString('ascii');

    // Remove specific parts of the decoded message
    msg = msg.substring(16);
    msg = msg.substring(0, msg.length - 15);

    // Decode the resulting substring again as base64
    buff = Buffer.from(msg, 'base64');
    msg = buff.toString('ascii');

    // Remove unwanted double quotes
    msg = msg.replace(/"/g, '');

    // Return the decoded password if the length is greater than 0
    if (msg.length > 0) {
      return msg;
    }

    return undefined;
  }

  getPageSize(page: string) {
    const pageSize = localStorage.getItem('pageSize')
      ? JSON.parse(localStorage.getItem('pageSize') || '')
      : {};
    return pageSize[page] || 10;
  }

  setPageSize(page: string, size: number) {
    const pageSize = localStorage.getItem('pageSize')
      ? JSON.parse(localStorage.getItem('pageSize') || '')
      : {};
    pageSize[page] = size;
    localStorage.setItem('pageSize', JSON.stringify(pageSize));
  }

  setPageSettingProject(searchText: string, start: number) {
    localStorage.setItem(
      'projectPageSetting',
      JSON.stringify({ searchText, start })
    );
  }

  getPageSettingProject() {
    if (localStorage.getItem('projectPageSetting')) {
      return JSON.parse(localStorage.getItem('projectPageSetting') || '{}');
    }
    return {
      start: 0,
      searchText: '',
    };
  }
  setRadio(page: string, inStock: string) {
    const InstockPage = localStorage.getItem('setRadio')
      ? JSON.parse(localStorage.getItem('setRadio') || '{}')
      : {};
    InstockPage[page] = inStock;
    localStorage.setItem('setRadio', JSON.stringify(InstockPage));
  }

  getRadio(page: string) {
    const InstockPage = localStorage.getItem('setRadio')
      ? JSON.parse(localStorage.getItem('setRadio') || '{}')
      : {};
    return InstockPage[page] || '';
  }
  //set checkbox value from storage
  setEmpCategory(nestedKey: string, value: string) {
    const selectedKey = localStorage.getItem('setEmpCategory')
      ? JSON.parse(localStorage.getItem('setEmpCategory') || '{}')
      : {};
    selectedKey[nestedKey] = value;
    localStorage.setItem('setEmpCategory', JSON.stringify(selectedKey));
  }
  //fetch checkbox value from storage
  getEmpCategory(nestedKey: string) {
    const selectedKey = localStorage.getItem('setEmpCategory')
      ? JSON.parse(localStorage.getItem('setEmpCategory') || '{}')
      : {};
    return selectedKey[nestedKey] || '';
  }

  setProjectSnapshot(nestedKey: string, projectId: string) {
    // Get the current projectSnapshot from localStorage
    const currentSnapshotString = localStorage.getItem('projectSnapshot');
    const currentSnapshot = currentSnapshotString
      ? JSON.parse(currentSnapshotString)
      : {};

    // Check if the nestedKey exists in the currentSnapshot
    if (currentSnapshot.hasOwnProperty(nestedKey)) {
      // Check if the projectId is not already in the nestedKey array
      if (!currentSnapshot[nestedKey].includes(projectId)) {
        currentSnapshot[nestedKey].push(projectId);
      }
    } else {
      // Create the nestedKey and set it as an array with the first projectId
      currentSnapshot[nestedKey] = [projectId];
    }

    // Save the updated projectSnapshot back to localStorage
    localStorage.setItem('projectSnapshot', JSON.stringify(currentSnapshot));
  }

  unsetProjectSnapshot(nestedKey: string, projectId: string) {
    // Get the current projectSnapshot from localStorage
    const currentSnapshotString = localStorage.getItem('projectSnapshot');
    const currentSnapshot = currentSnapshotString
      ? JSON.parse(currentSnapshotString)
      : {};

    // Check if the nestedKey exists in the currentSnapshot
    if (currentSnapshot.hasOwnProperty(nestedKey)) {
      // Find the index of the projectId in the nestedKey array
      const index = currentSnapshot[nestedKey].indexOf(projectId);

      if (index !== -1) {
        // Remove the projectId from the nestedKey array
        currentSnapshot[nestedKey].splice(index, 1);

        // If the nestedKey array is empty after removal, delete the key
        if (currentSnapshot[nestedKey].length === 0) {
          delete currentSnapshot[nestedKey];
        }

        // Save the updated projectSnapshot back to localStorage
        localStorage.setItem(
          'projectSnapshot',
          JSON.stringify(currentSnapshot)
        );
      }
    }
  }

  getProjectSnapshot(nestedKey: string, projectId: string) {
    // Get the current projectSnapshot from localStorage
    const currentSnapshotString = localStorage.getItem('projectSnapshot');
    const currentSnapshot = currentSnapshotString
      ? JSON.parse(currentSnapshotString)
      : {};

    // Check if the nestedKey exists in the currentSnapshot
    if (currentSnapshot.hasOwnProperty(nestedKey)) {
      // Check if the projectId is in the nestedKey array
      if (currentSnapshot[nestedKey].includes(projectId)) {
        return true;
      }
    }

    return false;
  }

  downloadFileFromBlob(res: Blob, name: string) {
    const url = window.URL.createObjectURL(res);
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  oneDecimalValidation = (control: AbstractControl) => {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return null;
    }
    if (!/^\d+(\.\d+)?$/.test(value)) {
      return { oneDecimal: true };
    }

    const numericValue = parseFloat(value);

    if (isNaN(numericValue) || numericValue < 0 || numericValue > 20000) {
      return { oneDecimal: true };
    }

    const decimalPlaces = (value.toString().split('.')[1] || '').length;

    if (decimalPlaces > 1) {
      return { oneDecimal: true };
    }

    return null;
  };

  budgetedMMValueValidator = (control: AbstractControl) => {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return null;
    }

    const numericValue = parseFloat(value);
    if (isNaN(numericValue) || numericValue < 0 || numericValue > 999) {
      return { decimalRange: true };
    }

    const decimalPlaces = (value.toString().split('.')[1] || '').length;

    if (decimalPlaces > 1) {
      return { decimalRange: true };
    }

    return null;
  };

  isExitValid(exitDate: any | null) {
    if (exitDate == null || exitDate == '' || exitDate == undefined) {
      return false;
    }
    var time = null;
    var dateParts = null;
    var day = null;
    var month = null;
    var year = null;
    var today = null;
    var ExitValid = null;
    time = this.dataService.currentTimeString.split(',')[0];
    dateParts = time.split('-');
    var monthNames: { [key: string]: string } = {
      January: '01',
      February: '02',
      March: '03',
      April: '04',
      May: '05',
      June: '06',
      July: '07',
      August: '08',
      September: '09',
      October: '10',
      November: '11',
      December: '12',
    };
    day = dateParts[0];
    month = monthNames[dateParts[1]];
    year = dateParts[2];
    today = year + '-' + month + '-' + day;
    ExitValid = today >= exitDate;
    return ExitValid;
  }

  getMonthHalfDates(date: any) {
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      // this condition is for Date format yyyy-mm-dd
      const parts = date.split('-');
      const year = parseInt(parts[0]);
      const month = parseInt(parts[1]);
      var day = parseInt(parts[2]);
      var formattedDay = day.toString().padStart(2, '0');
      var monthInLetters = this.dataService.months[month - 1].name;
      monthInLetters = monthInLetters.substr(0, 3).toUpperCase();
      const formattedDate = `${formattedDay}-${monthInLetters}-${year}`;
      return formattedDate;
    } else if (/^\d{2}-\d{2}-\d{4}$/.test(date)) {
      // this condition is for Date format dd-mm-yyyy
      const parts = date.split('-');
      const day = parseInt(parts[0]);
      const month = parseInt(parts[1]);
      const year = parseInt(parts[2]);
      var monthInLetters = this.dataService.months[month - 1].name;
      monthInLetters = monthInLetters.substr(0, 3).toUpperCase();
      const formattedDate = `${day}-${monthInLetters}-${year}`;
      return formattedDate;
    } else {
      return date;
    }
  }

  getLabel(u: any, maxlength: number) {
    if (u && u.length > maxlength) {
      return `${u.substring(0, maxlength)}...`;
    }
    return u;
  }

  OnboardExperienceValidator = (control: AbstractControl) => {
    const value = control.value;

    // Check if value is not a number
    if (isNaN(value)) {
      return { invalidExperience: true };
    }

    // Check if number is negative
    if (value < 0) {
      return { invalidExperience: true };
    }

    // Check decimal range
    const decimalRegex = /^-?\d+(\.\d{1,2})?$/;
    if (!decimalRegex.test(value)) {
      return { invalidExperience: true };
    } else {
      const decimalValue = parseFloat(value);
      const decimalPlaces = decimalValue.toString().split('.')[1];
      if (
        decimalPlaces &&
        (parseInt(decimalPlaces) < 1 || parseInt(decimalPlaces) > 11)
      ) {
        return { invalidExperience: true };
      }
    }

    return null; // Validation passed
  };

  noSpecialSymbolsValidator = (control: any) => {
    const value = control.value;
    if (!value) {
      return null;
    }
    const disallowedSymbolsRegex = /[!@#$%^&*()+=[\]{};':"\|,<>?`~]/;
    if (disallowedSymbolsRegex.test(value)) {
      return { noSpecialSymbols: true };
    }

    return null;
  };
  //function for getting fullname with or without mailid
  getNamewithMail(employee: any, type: string): any {
    var fullName = '';
    if (
      type == 'NameMailId' &&
      employee &&
      employee?.firstName &&
      employee?.lastName &&
      employee?.mailId
    ) {
      fullName =
        employee?.firstName +
        ' ' +
        employee?.lastName +
        ' (' +
        employee?.mailId +
        ')';
      return fullName;
    } else if (
      type == 'NameNoMailId' &&
      employee &&
      employee?.firstName &&
      employee?.lastName &&
      employee?.mailId
    ) {
      fullName = `${employee?.firstName}${`.`}${employee?.lastName}`;
      return fullName;
    } else if (
      type == 'NameNoMailIdNoDomain' &&
      employee &&
      employee?.firstName &&
      employee?.lastName &&
      employee?.mailId
    ) {
      fullName = `${employee?.firstName} ${employee?.lastName} (${
        employee.mailId.split('@')[0]
      })`;
      return fullName;
    } else if (type == 'dropdown') {
      return employee.map((emp: any) => {
        if (emp && emp?.firstName && emp?.lastName && emp?.email) {
          emp.fullName = `${emp.firstName} ${emp.lastName} (${emp.email})`;
        }
        return emp;
      });
    } else {
      return;
    }
  }

  getMailOnBasedOnRole(userValue: any): any {
    var fullName = '';
    if (userValue.roleClass.code == 'RA002') {
      var employee = userValue.employee;
      if (
        employee &&
        (employee?.mailId == null ||
          employee?.mailId === '' ||
          !employee?.mailId.includes('@'))
      )
        return 'NoNeedsReportsTo';
      return employee.mailId.split('@')[0];
    }
    return 'NoNeedsReportsTo';
  }

  fnTruncateString(str: string, truncateFrom: number, truncateTo: number) {
    return str.substring(truncateFrom, truncateTo);
  }

  fnTruncateEmail(str: string) {
    let splitString = str.split('@');
    return splitString[0];
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  getPageSearchText(page: string) {
    const searchText = localStorage.getItem('searchText')
      ? JSON.parse(localStorage.getItem('searchText') || '')
      : {};
    return searchText[page] || '';
  }

  setPageSearchText(page: string, text: string) {
    const searchText = localStorage.getItem('searchText')
      ? JSON.parse(localStorage.getItem('searchText') || '')
      : {};
    searchText[page] = text;
    localStorage.setItem('searchText', JSON.stringify(searchText));
  }

  //get Text cut from middle with horizontal line.
  fnGetTextDecoration(status: string) {
    if (status === 'CANCELLED') {
      return 'line-through';
    } else {
      return '';
    }
  }

  customEmailValidator = (type: string): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } | null => {
       const emailPersonalPattern =
      /^\s*[a-zA-Z._][a-zA-Z0-9._]*@[a-zA-Z]+\.[a-zA-Z]{2,4}(\.[a-zA-Z0-9]{2,4})*\s*$/;

    const emailPattern =
      /^\s*[a-zA-Z._][a-zA-Z0-9._]*@truminds\.com\s*$/;

      const emailId =
        type === 'official' ? emailPattern : emailPersonalPattern;

      const value = control.value;

      if (!value) {
        return null;
      }

      const trimmedEmail = value.trim();

      if (!emailId.test(trimmedEmail)) {
        return { invalidEmail: true };
      }

      return null;
    };
  };

  marksValidator(
    minValue: number,
    maxValue: number,
    isDecimal: boolean = true
  ) {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (value === null || value === undefined || value === '') {
        return null; // If the value is empty, don't validate
      }

      if (value < minValue || value > maxValue) {
        return { invalidRange: true }; // Validation failed
      }

      // Regular expression to validate number with up to 2 decimal places
      const pattern = !isDecimal ? /^[^.]*$/ : /^\d+(\.\d{1,2})?$/;

      if (!pattern.test(value)) {
        return { invalidDecimalValue: true }; // Validation failed
      }

      return null; // Validation passed
    };
  }

  fnGetManager(project: any, keys: string[] | number[]) {
    const projectManagerLabel: string[] = [];
    if (!project || !keys || keys.length === 0) {
      return projectManagerLabel;
    }
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (project[key]) {
        projectManagerLabel.push(project[key]);
      }
    }
    return projectManagerLabel;
  }

  /**
   * used in auditing
   * used to convert date variable
   * of value Date Object and returns
   * string in format dd-mmm-yyyy i.e., 10-Apr-2024
   */
  fnConvertDate(date: any): string {
    let formattedDate = '';
    if (!date) {
      formattedDate = '';
    } else if (date instanceof Date) {
      const day = date.getDate().toString().padStart(2, '0');
      const month = this.dataService.months[date.getMonth()].name;
      const year = date.getFullYear();
      formattedDate = `${day}-${month}-${year}`;
    } else if (typeof date == 'string') {
      formattedDate = date;
    }
    return formattedDate;
  }

  getPageSettingEmployee() {
    if (localStorage.getItem('employeePageSetting')) {
      return JSON.parse(localStorage.getItem('employeePageSetting') || '{}');
    }
    return {
      start: 0,
      searchText: '',
      filter: '',
    };
  }

  salaryValidator(
    minValue: number,
    maxValue: number | string,
    isDecimal: boolean,
    type: string = ''
  ) {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (value === null || value === undefined || value === '') {
        return null; // If the value is empty, don't validate
      }
      if (minValue && maxValue && (value < minValue || value > maxValue)) {
        return { invalidRange: true }; // Validation failed
      } else if (value < minValue) {
        return { invalidRange: true }; // Validation failed
      }

      // Regular expression to validate number with up to 2 decimal places
      // const pattern = /^[^.]*$/ //!isDecimal ? /^[^.]*$/ : /^\d+(\.\d{1,2})?$/;
      let pattern: any = '';
      if (type === 'tctc') {
        pattern = /^[^.]*$/;
        if (!pattern.test(value)) {
          return { invalidDecimalValue: true }; // Validation failed
        }
      } else if (type === 'basicOrFlexi') {
        pattern = /^\d+(\.\d{1,2})?$/;
        if (!pattern.test(value)) {
          return { invalidDecimalValue: true }; // Validation failed
        }
      }
      if (type !== '' && !pattern.test(value)) {
        return { invalidDecimalValue: true }; // Validation failed
      }

      return null; // Validation passed
    };
  }

  createKeyValuePairs(data: any) {
    const keyValuePairs: any = {};

    data.forEach((item: any) => {
      if (item.monthly && item.monthly.key) {
        keyValuePairs[item.monthly.key] = item.monthly.value;
      }
      if (item.annually && item.annually.key) {
        keyValuePairs[item.annually.key] = item.annually.value;
      }
    });

    return keyValuePairs;
  }

  regexValidator(regex: RegExp, errorKey: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const response = regex.test(control.value);
      return response ? { [errorKey]: response } : null;
    };
  }

  futureDateValidation(errorKey: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const currentDate = new Date();
      const formattedControlDate = new Date(control.value);
      return currentDate < formattedControlDate ? { [errorKey]: true } : null;
    };
  }

  setDatesDuration(page: string, dates: object) {
    const datesDuration = localStorage.getItem('customDates')
      ? JSON.parse(localStorage.getItem('customDates') || '')
      : {};
    datesDuration[page] = dates;
    localStorage.setItem('customDates', JSON.stringify(datesDuration));
  }

  getDatesDuration(page: string) {
    const searchText = localStorage.getItem('customDates')
      ? JSON.parse(localStorage.getItem('customDates') || '')
      : {};
    return searchText[page] || '';
  }

  setDashboardSortingPreference(key: string, value: number): void {
    const sortingObj = localStorage.getItem('dashboardSortingPreference')
      ? JSON.parse(localStorage.getItem('dashboardSortingPreference') || '')
      : {};
    sortingObj[key] = value;
    localStorage.setItem(
      'dashboardSortingPreference',
      JSON.stringify(sortingObj)
    );
  }

  getDashboardSortingPreference(key: string): number {
    const sortingObj = localStorage.getItem('dashboardSortingPreference')
      ? JSON.parse(localStorage.getItem('dashboardSortingPreference') || '')
      : {};
    return sortingObj[key];
  }

  deleteDatesDuration(page: string) {
    const datesDuration = localStorage.getItem('customDates')
      ? JSON.parse(localStorage.getItem('customDates') || '')
      : {};

    // Check if the page exists in the datesDuration object
    if (datesDuration[page]) {
      delete datesDuration[page]; // Delete the specific page entry
      localStorage.setItem('customDates', JSON.stringify(datesDuration)); // Update localStorage
    }
  }

  maskAccountNumber(number: number | string) {
    if (!number) {
      return '--';
    }
    number = typeof number === 'string' ? number : number.toString();
    const visibleStartChars = 2; // Number of visible characters at the start
    const visibleEndChars = 4; // Number of visible characters at the end
    const totalVisibleChars = visibleStartChars + visibleEndChars;
    if (number.length <= totalVisibleChars) {
      return number; // Account number is too short to mask
    }

    const maskedChars = number.length - totalVisibleChars;
    const maskedPart = '*'.repeat(maskedChars);
    const visiblePartStart = number.substring(0, visibleStartChars);
    const visiblePartEnd = number.substring(number.length - visibleEndChars);
    return visiblePartStart + maskedPart + visiblePartEnd;
  }

  /**
   * remove all backdrop fade modal when modal open and error interceptor logouts
   */
  dismissModalFade() {
    document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
  }

  nameValidator(): ValidatorFn {
    const alphabetRegex = /^[A-Za-z. ]+$/; // only alphabets + middle spaces
    return (control: AbstractControl): ValidationErrors | null => {
      const rawValue = control.value ?? ''; // original value
      const value = rawValue.trim(); // trimmed for whitespace check

      // Rule 0: Empty or only-whitespace not allowed
      if (rawValue.length > 0 && value.length === 0) {
        return { noWhitespace: true };
      }

      if (!value) {
        return null; // allow empty field if not required
      }

      // Rule 1: Only alphabets and spaces
      if (!alphabetRegex.test(value)) {
        return { onlyAlphabets: true };
      }

      // Rule 2: No leading/trailing whitespace
      if (value !== rawValue) {
        return { noWhitespace: true };
      }

      return null; // valid
    };
  }

  joinWithAnd(items: string[]): string {
    if (items.length === 1) {
      return items[0];
    }

    if (items.length === 2) {
      return `${items[0]} and ${items[1]}`;
    }

    return `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`;
  }
}
